import { Component } from '@angular/core';

@Component({
  selector: 'wun-exhibitions',
  imports: [],
  templateUrl: './exhibitions.component.html',
  styleUrl: './exhibitions.component.scss'
})
export class ExhibitionsComponent {

}
